import { render, staticRenderFns } from "./RegisterNonMember.vue?vue&type=template&id=511c20ec&"
import script from "./RegisterNonMember.vue?vue&type=script&lang=js&"
export * from "./RegisterNonMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports